import { Fragment, memo } from 'react';

import { CommentRow, InfoRow, InfoRowSection } from 'containers/components/EntityDetailV2';

import ActivityDetailContainer from '../ActivityDetailContainer';

const AnnotationDetail = memo(({ activity, getIsCommentCollapsed, labels, shared }) => {
    const { companyContent, finalContactContent, opportunityRow, rightContent, titleRow } = shared;

    return (
        <ActivityDetailContainer
            activity={activity}
            content={{
                main: (
                    <Fragment>
                        <InfoRowSection>
                            <InfoRow label={labels.subject} value={activity.Subject} />
                        </InfoRowSection>
                        <CommentRow
                            text={activity.Description}
                            getIsCommentCollapsed={getIsCommentCollapsed}
                        />
                    </Fragment>
                ),
                right: (
                    <Fragment>
                        {titleRow}
                        <InfoRowSection>
                            <InfoRow
                                label={labels.account}
                                value={companyContent}
                                rightContent={rightContent}
                            />
                            <InfoRow label={labels.contact} value={finalContactContent} />
                            <InfoRow label={labels.role} value={activity.ContactRole} />
                            {opportunityRow}
                        </InfoRowSection>
                    </Fragment>
                ),
            }}
        />
    );
});

AnnotationDetail.displayName = 'AnnotationDetail';

export default AnnotationDetail;
